

<h3>{{question.questionNumber}}. {{question.category.name}}</h3>
<div [innerHtml]="question.text | safe: 'html'"></div>

@for (q of question.answerChoices; track q; let i = $index) {
  <div>
    <button type="button" class="btn surveyButtons mt-3 mb-3" (click)="Answer(i)" [ngClass]="{'answered': i==answeredIndex}">{{q.text}}</button>
  </div>
}


<button type="button" class="btn btn-info float-end" data-bs-toggle="modal" data-bs-target="#hintModal">HINT</button>

<div class="modal fade" id="hintModal" tabindex="-1" aria-labelledby="hintModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="hintModalLabel">InvestingforCatholics.com says</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        {{question.hint}}
      </div>
    </div>
  </div>
</div>
